import DestinationPage from "@/components/DestinationPage";
const related = [
  { name: "Turcia", slug: "turcia", image: "https://images.unsplash.com/photo-1774850691859-0e339f94bebb?w=600&q=80" },
  { name: "Spania", slug: "spania", image: "https://images.unsplash.com/photo-1758471206484-0eaa2568320c?w=600&q=80" },
  { name: "Muntenegru", slug: "muntenegru", image: "https://images.unsplash.com/photo-1689517686262-628708bbc5d7?w=600&q=80" },
];
export default function GreciaPage() {
  return (
    <DestinationPage
      name="Grecia" nameRo="Grecia" slug="grecia" flag="🇬🇷"
      heroImage="https://images.unsplash.com/photo-1506242592132-b7476b527d50?w=1920&q=80"
      metaTitle="Vacanță în Grecia din Chișinău | Santorini, Creta, Rhodos – Premium Style Travel"
      metaDescription="Oferte vacanță Grecia 2025-2026 din Chișinău. Santorini, Creta, Rhodos, Corfu, Mykonos. Zbor + hotel. Sună +373 60609292 – Premium Style Travel."
      tagline="Marea Egee, insule de vis și cupolele albastre din Santorini te așteaptă cu cele mai frumoase apusuri din lume."
      description="Grecia este sinonimă cu vacanța perfectă — ape turcoaz, insule cu peisaje de vis, gătit mediteranean și ospitalitate caldă. Santorini fascinează prin cupolele albastre și apusurile de soare legendare. Creta, cea mai mare insulă greacă, oferă plaje magnifice, istorii minoice și gastronomie autentică. Rhodos combină medieval cu modern, iar Mykonos și Corfu completează tabloul unui paradis mediteranean. Grecia este destinația ideală atât pentru cupluri, cât și pentru familii."
      highlights={[
        "Santorini – cupolele albastre și apusurile din Oia",
        "Creta – Palatul Knosos și plaja Elafonisi",
        "Rhodos – Orașul Medieval UNESCO și plaje superbe",
        "Mykonos – viața de noapte și farmecul cicladelor",
        "Corfu – verdeață luxuriantă și arhitectură venețiană",
        "Atena – Acropole, Partenon și muzeele istorice",
        "Zakynthos – plaja Navagio cu naufragiul iconic",
        "Bucătăria greacă – tzatziki, souvlaki, baklava",
      ]}
      included={[
        "✈️ Zbor dus-întors din Chișinău",
        "🏨 Cazare hotel / vilă 3★–5★",
        "🚌 Transfer aeroport – hotel – aeroport",
        "🛡️ Asigurare medicală de călătorie",
        "📋 Taxe și comisioane incluse",
      ]}
      faqs={[
        { q: "Care insulă din Grecia este cea mai potrivită pentru prima vizită?", a: "Creta este ideală pentru prima vizită – are plaje diverse, hoteluri pentru toate bugetele, istorie fascinantă și conexiuni aeriene directe." },
        { q: "Este nevoie de viză pentru Grecia?", a: "Grecia face parte din spațiul Schengen. Cetățenii moldoveni cu biometrie pot intra fără viză. Consultați-ne pentru detalii actualizate." },
        { q: "Când este cel mai bun sezon în Grecia?", a: "Mai–octombrie. Iunie și septembrie sunt ideale: mai puțin aglomerat, prețuri mai bune și temperaturi plăcute (25-30°C)." },
        { q: "Cât durează zborul din Chișinău spre Grecia?", a: "Aproximativ 2–2h30 spre Creta sau Rhodos cu zbor direct charter." },
        { q: "Grecia este scumpă?", a: "Depinde de destinație. Creta și Rhodos sunt accesibile. Santorini și Mykonos sunt mai premium. Avem pachete pentru toate bugetele." },
      ]}
      relatedDestinations={related}
    />
  );
}
